// Usage: In invite modal
<template>
  <div v-click-outside="clickOutsideContextMenu">
    <div v-if="disabled" class="overlay-disable-setting"></div>
    <div @click="handleClickShowMenu">
      <aha-input
        readonly
        :value="getRole()"
        class="role-value-input cursor-pointer border-none"
        :class="{
          'text-primary-90': showRoleSelectionContextMenu,
        }"
      >
        <template #append>
          <aha-icon
            name="arrow"
            class="down-arrow absolute top-3.5 right-2"
            :class="{
              'text-primary-90': (showRoleSelectionContextMenu),
            }"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          />
        </template>
      </aha-input>
    </div>
    <div
      v-show="showRoleSelectionContextMenu"
      class="context-menu-role absolute right-0"
    >
      <ul class="w-48">
        <li
          v-if="showRoleAdmin"
          class="context-menu-item py-2"
          @click="changeInvitedRole(role.ADMIN)"
        >
          <div class="flex">
            <aha-icon
              :class="{'invisible': invitedRole !== role.ADMIN}"
              name="check"
              class="text-primary-90 min-w-6 mt-1"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <div class="grid">
              <span class="leading-6 capitalize" :class="{'font-bold': invitedRole === role.ADMIN}">
                {{ role.ADMIN }}
              </span>
              <span class="text-xs whitespace-normal">
                {{ $i18nPresenter.t('Invite, remove member, manage member role') }}
              </span>
            </div>
          </div>
        </li>
        <li
          class="context-menu-item py-2"
          :class="{'h-10': isInviteTeam}"
          @click="changeInvitedRole(role.EDITOR)"
        >
          <div class="flex justify-center">
            <aha-icon
              :class="{'invisible': invitedRole !== role.EDITOR}"
              name="check"
              class="text-primary-90 min-w-6 mt-1"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <div class="grid">
              <span class="leading-6 capitalize" :class="{'font-bold': invitedRole === role.EDITOR}">
                {{ isInviteTeam ? 'Member' : 'Editor' }}
              </span>
              <span class="text-xs whitespace-normal" v-if="!isInviteTeam">
                {{ $i18nPresenter.t('Organize, create and edit presentations') }}
              </span>
            </div>
          </div>
        </li>
        <li
          class="context-menu-item py-2"
          @click="changeInvitedRole(role.VIEWER, $event)"
          v-if="!isInviteTeam"
        >
          <div class="flex">
            <aha-icon
              :class="{'invisible': invitedRole !== role.VIEWER}"
              name="check"
              class="text-primary-90 min-w-6 mt-1"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <div class="grid">
              <span class="leading-6 capitalize" :class="{'font-bold': invitedRole === role.VIEWER}">
                {{ role.VIEWER }}
                <IconNeedUpgradePlan
                  v-if="planBenefit.abTest && planBenefit.teamWorkCollaboration"
                  ref="iconNeedUpgradePlanComponentInviteRole"
                  :noPermission="planBenefit.teamWorkCollaboration &&
                    !planBenefit.teamWorkCollaboration.presentOnlyRole"
                  :upgradePlan="planBenefit.teamWorkCollaboration.presentOnlyRole_planName"
                  featureName="Collaboration View Role"
                />
              </span>
              <span class="text-xs whitespace-normal">
                {{ $i18nPresenter.t('View and present') }}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import utils from '@/util'
import constants from '@/constant'
import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'

export default {
  components: {
    IconNeedUpgradePlan,
  },
  props: {
    invitedRole: {
      type: String,
      default: 'editor', // editor / viewer
    },
    isInviteTeam: {
      type: Boolean,
      default: false,
    },
    hideRoleAdmin: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    presentation: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
    absolute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showRoleSelectionContextMenu: false,
      role: constants.role,
    }
  },
  computed: {
    ...mapState({
      planBenefit: (state) => state.planBenefit,
    }),
    ...mapGetters([
      'currentUserIsTeamOwnerOrAdmin',
    ]),
    showRoleAdmin() {
      return (this.currentUserIsTeamOwnerOrAdmin || !this.$store.state.currentAccount.id) && !this.hideRoleAdmin
    },
  },
  methods: {
    changeInvitedRole(role, event) {
      if (this.planBenefit.abTest && event && this.planBenefit.teamWorkCollaboration &&
      !this.planBenefit.teamWorkCollaboration.presentOnlyRole && role === this.role.VIEWER) {
        if (this.$refs.iconNeedUpgradePlanComponentInviteRole) {
          event.stopPropagation()
          this.$refs.iconNeedUpgradePlanComponentInviteRole.toggleTooltip()
          return
        }
      }
      this.$emit('changeInvitedRole', role)
      this.showRoleSelectionContextMenu = false
    },
    getRole() {
      if (this.invitedRole === 'admin') return 'Admin'
      if (this.invitedRole === 'viewer') return 'Viewer'
      return this.isInviteTeam ? 'Member' : 'Editor'
    },
    clickOutsideContextMenu() {
      this.showRoleSelectionContextMenu = false
    },
    handleClickShowMenu() {
      this.showRoleSelectionContextMenu = !this.showRoleSelectionContextMenu
      if (this.isInviteTeam && !this.$store.state.currentAccount.id) {
        utils.mixpanelTracking(utils.getGACategories(this.$route.name), 'SideNav > Add team member > Open the list of roles', '', '', {
          userId: this.$store.state.currentUser.id,
          plan: this.$store.state.currentUser.plan,
        })
      }
    },
  },
}
</script>
<style scoped lang='scss'>
.context-menu-role {
  @apply flex flex-col items-start p-1 mt-4;
  border: 1px solid rgba(235, 235, 235, 1);
  z-index: 9999;
  background: #FFFFFF;
  box-shadow: 3px 3px 5px 0px rgba(210, 214, 224, 0.42);
  border-radius: 0.375rem;
}
::v-deep .aha-input {
  cursor: pointer;
}
.role-value-input {
  &:hover {
    @apply text-primary-90;
    .down-arrow {
      @apply text-primary-90;
    }
  }
}
.overlay-disable-setting {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full z-10;
}

</style>

<style lang='scss'>
.role-value-input.border-none > input {
  border: none;
  height: 38px;

  &:hover, &:focus {
    background-color: #fff;
  }
}
</style>
